import React from "react";
// Import Link
import { Link } from "react-router-dom";
// import Img
import Img from "../../../src/assets/img/airplane.png";

const CorporateTravelText = () => {
  return (
    <>
      <section id="about_us_top" className="section_padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about_us_left">
                {/* <h5>About us</h5> */}
                <h2>Corporate Travel</h2>
                <p>
                At House of Polani, we recognize that business travel demands a unique blend of efficiency, flexibility, and reliability. Our corporate travel division stands ready to transform your business travel experience with comprehensive solutions that go beyond simple bookings. We provide seamless end-to-end travel management, ensuring your team can focus on business while we handle every aspect of their journey.
                </p>
                <p>
                Our dedicated corporate team operates around the clock, providing instant support for any travel-related needs. From last-minute schedule changes to emergency assistance, our experienced professionals ensure your business travel runs smoothly. We understand that cost management is crucial for businesses, which is why we leverage our strong relationships with airlines and hotels to secure preferential corporate rates and implement efficient booking strategies that align with your company's travel policy.
                </p>
                <p>
                When it comes to group travel and events, our expertise shines through in coordinating complex itineraries for conferences, meetings, and corporate retreats. We assign dedicated account managers who understand your business needs and ensure consistent service quality across all your travel requirements. Our sophisticated online booking tools, combined with detailed expense tracking and reporting systems, provide complete transparency and control over your travel spending.
                {" "}
                </p>
                {/* <Link to="#!" className="btn btn_theme btn_sm">
                  More
                </Link> */}
              </div>
            </div>
            {/* <div className="col-lg-6">
              <div className="about_us_right">
                <img src={Img} />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default CorporateTravelText;
